<div class="scrollable-wrapper">
  <div class="scrollable-content" (scroll)="(null)" #scrollableContainer>
    <ng-content></ng-content>
  </div>

  <div
    class="shadow shadow__bottom"
    [class.hide-on-scroll]="
      Math.floor(
        scrollableContainer.scrollHeight - scrollableContainer.scrollTop
      ) === scrollableContainer.clientHeight
    "></div>

  <div
    class="shadow shadow__top"
    [class.hide-on-scroll]="
      Math.floor(scrollableContainer.scrollTop) === 0
    "></div>

  <div
    class="shadow shadow__left"
    [class.hide-on-scroll]="
      Math.floor(scrollableContainer.scrollLeft) === 0
    "></div>

  <div
    class="shadow shadow__right"
    [class.hide-on-scroll]="
      Math.floor(
        scrollableContainer.scrollWidth - scrollableContainer.scrollLeft
      ) === scrollableContainer.clientWidth
    "></div>
</div>
